import styled from 'styled-components';
import { BREAK_POINTS } from '../../consts/style';

export const Header = styled.div`
  [data-id='leading'] {
    font-size: 24px;
    font-weight: 400;
    line-height: 28px;
    text-align: center;
    margin: 0 0 48px;

    @media screen and (min-width: ${BREAK_POINTS.MIN.MD}) {
      font-size: 32px;
      line-height: 40px;
      margin: 0 auto 48px;
      max-width: 608px;
    }

    @media screen and (min-width: ${BREAK_POINTS.MIN.LG}) {
      margin: 0 auto 64px !important;
      max-width: 728px;
    }
  }

  [data-id='text'] {
    margin-bottom: 48px;

    @media screen and (min-width: ${BREAK_POINTS.MIN.LG}) {
      margin-bottom: 64px;
    }
  }

  [data-id='leading'] + [data-id='text'] {
    margin-top: -32px;

    @media screen and (min-width: ${BREAK_POINTS.MIN.LG}) {
      margin-top: -48px;
    }
  }
`;
